var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page noselect",
      class: { withSearchbar: _vm.$store.getters.searchIsRenderedNow },
    },
    [
      _c("div", { staticClass: "spacer-25" }),
      _c("DrinkCards", {
        attrs: { "show-alternative": true, lastGotoFoods: true },
      }),
      _c("FixBasket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }